import { Breadcrumbs, Link } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { galleryActions } from "../actions";

const styles = {
  breadCrumb: {
    fontSize: "22px",
    marginBottom: "5px",
    '@media (max-width: 600px)': {
      fontSize: '12.5px',
    }
  },
  prodDetails: {
    fontSize: "22px",
    '@media (max-width: 600px)': {
      fontSize: '12.5px',
      marginTop: "5px"
    }
  },
  link: {
    fontSize: "22px",
    cursor: "pointer",
    '@media (max-width: 600px)': {
      fontSize: '13.5px'
    }
  },
};

const Breadcrumb = ({ prodCategoria, prodRubro, prodSubRubro }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { categoria, rubro, subRubro, promocion } = useSelector(
    (state) => state.gallery
  );

  const setCategoria = (categoria = "", rubro = "", subRubro = "", promocion = "") => {
    dispatch(galleryActions.setSearchTerm(""))
    dispatch(
      galleryActions.setCategoria(categoria === "Todas" ? "" : categoria)
    );
    dispatch(galleryActions.setRubro(rubro));
    dispatch(galleryActions.setSubRubro(subRubro));
    dispatch(galleryActions.setPromocion(promocion));
    if (location.pathname !== "/") navigate("/");
  };

  return (
    <Breadcrumbs
      aria-label="breadcrumb"
      sx={prodCategoria ? styles.prodDetails : styles.breadCrumb}
    >
      {prodCategoria && (
        <Link
          underline="hover"
          color="inherit"
          onClick={() => setCategoria("Todas")}
          sx={styles.link}
        >
          Inicio
        </Link>
      )}
      {(categoria || prodCategoria) && (
        <Link
          underline="hover"
          color="inherit"
          onClick={() => {
            prodCategoria
              ? setCategoria(prodCategoria, "", "")
              : setCategoria(categoria, "", "");
          }}
          sx={styles.link}
        >
          {prodCategoria || categoria}
        </Link>
      )}
      {(rubro || prodRubro) && (
        <Link
          underline="hover"
          color="inherit"
          onClick={() => {
            prodCategoria && prodRubro
              ? setCategoria(prodCategoria, prodRubro, "")
              : setCategoria(categoria, rubro, "");
          }}
          sx={styles.link}
        >
          {prodRubro || rubro}
        </Link>
      )}
      {(subRubro || prodSubRubro) && (
        <Link
          underline="hover"
          color="text.primary"
          sx={styles.link}
          onClick={() => {
            prodCategoria && prodRubro && prodSubRubro
              ? setCategoria(prodCategoria, prodRubro, prodSubRubro)
              : setCategoria(categoria, rubro, subRubro);
          }}
        >
          {prodSubRubro || subRubro}
        </Link>
      )}
      {promocion && (
        <Link
          underline="hover"
          color="text.secondary"
          sx={styles.link}
          onClick={() => {
            setCategoria("", "", "", promocion);
          }}
        >
          {promocion}
        </Link>
      )}
    </Breadcrumbs>
  );
};

export default Breadcrumb;
